import { createTheme } from '@mui/material/styles';

// Темная тема (Dark Tactical UI)
export const darkTheme = createTheme({
  palette: {
    mode: 'dark',
    primary: { main: '#a43150', dark: '#76253f', light: '#c15b75' },
    secondary: { main: '#2e4664' },
    background: { default: '#0a172b', paper: 'rgba(16, 37, 68, 0.95)' },
    text: { primary: '#f4f6fa', secondary: '#a9b4c7' },
    error: { main: '#e05b78' },
    success: { main: '#22c55e' },
  },
  typography: {
    fontFamily: 'Arial, Helvetica, sans-serif',
    button: { textTransform: 'uppercase', letterSpacing: '1px', fontWeight: 'bold' },
    h6: { letterSpacing: '1px' },
  },
  shape: { borderRadius: 6 },
  components: {
    MuiPaper: {
      styleOverrides: {
        root: { backdropFilter: 'blur(10px)', border: '1px solid rgba(164, 49, 80, 0.3)', boxShadow: '0 25px 80px rgba(0,0,0,0.7)' },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          '&.MuiButton-containedPrimary': {
            background: 'linear-gradient(180deg, #b33a59 0%, #a43150 100%)',
            boxShadow: '0 4px 15px rgba(164, 49, 80, 0.4)',
            '&:hover': { background: 'linear-gradient(180deg, #c15b75 0%, #b33a59 100%)' },
          },
        },
      },
    },
    MuiDialog: { styleOverrides: { paper: { borderRadius: 14, background: 'rgba(10, 23, 43, 0.95)', border: '1px solid #304463' } } },
    MuiListItemText: { styleOverrides: { secondary: { color: '#71839d !important' } } },
  },
});

// Светлая тема (Служебная)
export const lightTheme = createTheme({
  palette: {
    mode: 'light',
    primary: { main: '#a43150', dark: '#76253f', light: '#c15b75' },
    secondary: { main: '#304463' },
    background: { default: '#f4f6fa', paper: '#ffffff' },
    text: { primary: '#0a172b', secondary: '#53647c' },
    error: { main: '#e05b78' },
    success: { main: '#22c55e' },
  },
  typography: {
    fontFamily: 'Arial, Helvetica, sans-serif',
    button: { textTransform: 'uppercase', letterSpacing: '1px', fontWeight: 'bold' },
    h6: { letterSpacing: '1px' },
  },
  shape: { borderRadius: 6 },
  components: {
    MuiPaper: {
      styleOverrides: {
        root: { border: '1px solid #e0e0e0', boxShadow: '0 10px 30px rgba(0,0,0,0.1)' },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          '&.MuiButton-containedPrimary': {
            background: 'linear-gradient(180deg, #b33a59 0%, #a43150 100%)',
            color: '#fff',
            '&:hover': { background: 'linear-gradient(180deg, #c15b75 0%, #b33a59 100%)' },
          },
        },
      },
    },
    MuiDialog: { styleOverrides: { paper: { borderRadius: 14 } } },
  },
});
